import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { RegisterButton } from "../bracelet/RegisterButton";

interface VerseActionsProps {
  onNextVerse: () => void;
  showRegisterButton?: boolean;
  onRegisterClick?: () => void;
}

export function VerseActions({ onNextVerse, showRegisterButton, onRegisterClick }: VerseActionsProps) {
  return (
    <div className="flex flex-col items-center gap-6 pt-4">
      <Button
        variant="outline"
        className="flex items-center gap-2 w-full max-w-[200px]"
        onClick={onNextVerse}
      >
        <ChevronRight className="w-4 h-4" />
        Next Verse
      </Button>
      
      {showRegisterButton && onRegisterClick && (
        <RegisterButton onClick={onRegisterClick} />
      )}
    </div>
  );
}